<template>
  <div>
    <b-card class="file-uploader-background">
      <a :href="previewImageUrl" target="_blank">
        <img  :src="previewImageUrl" 
              :style="{ 'max-width': '100%', 'height': 'auto', 'max-height': `${previewHeight}px`}" />
      </a>
    </b-card>

    <uploader
      ref="fileUploader"
      :upload-url="baseUrl + uploadUrl"
      :value-changed="valueChanged"
      :allow-delete="!!previewImageUrl"
      :disabled="disabled"
      @input="onInput"
    />
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService';
import Uploader from './Uploader';

export default {
  name: "ImageUploader",

  props: {
    uploadUrl: {
      type: String,
      default: '/'
    },
    previewHeight: {
      type: Number,
      default: 100
    },
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  components : {
    Uploader
  },

  data() {
    return {
      uploadImageUrl: null
    }
  },

  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    },

    authorizationHeader() {
      return AuthenticationService.authorizationHeader;
    },

    previewImageUrl() {
      return this.uploadImageUrl ? window.URL.createObjectURL(this.uploadImageUrl) : this.value;
    },
  },

  watch: {
    value (newVal, oldVal) {
      if (newVal !== oldVal && !newVal)
      {
        this.$refs?.fileUploader?.reset();
        this.uploadImageUrl = null;
      }
    },
  },
  
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },

    valueChanged(event) {
      this.uploadImageUrl = event?.value[0];
      this.$emit('value-changed', event, this.uploadImageUrl);
      if (this.uploadImageUrl) {
        this.$emit('input', event?.value);
      }
    },

    uploadImage() {
      return this.$refs.fileUploader.uploadFile();
    }
  }
}
</script>

<style scoped>
  .file-uploader-background {
    background-color: #808080;
    background-image: 
        linear-gradient(45deg, rgba(255,255,255,.5) 25%, transparent 25%, transparent 75%, rgba(255,255,255,.5) 75%, rgba(255,255,255,.5)),
        linear-gradient(45deg, rgba(255,255,255,.5) 25%, transparent 25%, transparent 75%, rgba(255,255,255,.5) 75%, rgba(255,255,255,.5));
    background-size: 20px 20px;
    background-position: 0 0, 10px 10px;
    border-radius: 0.25rem;
  }
</style>